import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "./vfs_fonts";
import moment from "moment";
import { formatNumber } from "../../../utils/formatNumber";
import "moment/locale/th";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew.ttf",
    italics: "THSarabunNew.ttf",
    bolditalics: "THSarabunNew.ttf",
  },
};

export function generateInvoicePdfBlob(transaction) {
  console.log('transaction',transaction);
  return new Promise((resolve) => {
    const totalPrice = transaction.items.reduce(
      (sum, item) => sum + (item.netPrice || 0),
      0
    );

    const docDefinition = {
      content: [
        { text: "ใบแจ้งหนี้ (Invoice)", style: "header" },

        {
          text: `บริษัท มหานคร เมทอลสแคร็ป จำกัด
92/78 หมู่ที่ 9 ถนนฉลองกรุง แขวงลำผักชี เขตหนองจอก กรุงเทพมหานคร 10530
โทร: 098-2657498 , 089-2029400
เปิด: จันทร์ - เสาร์ เวลา 8.00 - 16.00 น. (ปิดทุกวันอาทิตย์)`,
          margin: [0, 5, 0, 15],
        },

        {
          columns: [
            [
              {
                text: `ชื่อรายการสินค้า: ${transaction.items[0]?.productName || "-"}`,
              },
              { text: `เลขที่Batch: ${transaction.billNumber || "-"}` },
              { text: `เลขที่ใบสั่งซื้อ: ${transaction.orderNumber || "-"}` },
              {
                text: `ส่งไปที่:\n[C${String(transaction.customerId || "-").padStart(3, "0")}] ${
                  transaction.customerName || "-"
                }
${transaction.customer?.address || ""}
${transaction.customer?.phone || ""}`,
              },
            ],
            [
              {
                text: transaction.createdAt
                  ? (() => {
                      const date = moment(transaction.createdAt).locale("th");
                      const buddhistYear = date.year() + 543;
                      return `วันที่เปิดBatch: ${date.format("DD/MM/")}${buddhistYear} ${date.format("HH:mm")}`;
                    })()
                  : "วันที่เปิดBatch: -",
              },
              {
                text: transaction.shipping && transaction.shipping.createdAt
                  ? (() => {
                      const date = moment(
                        transaction.shipping.createdAt
                      ).locale("th");
                      const buddhistYear = date.year() + 543;
                      return `วันที่ขาย: ${date.format("DD/MM/")}${buddhistYear} ${date.format("HH:mm")}`;
                    })()
                  : "วันที่ขาย: -",
              },
              {
                text: `เลขตู้ขนส่ง: ${transaction.shipping && transaction.shipping.transportBoxNumber || "-"}`,
              },
              { text: `ชื่อคนขับ: ${transaction.shipping && transaction.shipping.driverName || "-"}` },
              // {
              //   text: `รถขนส่ง: ${transaction.car.type || "-"} ${transaction.car.license || "-"}`,
              // },
              {
                text: transaction.shipping?.phoneNumber
                  ? `โทรศัพท์ ${transaction.shipping.phoneNumber.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                  : "โทรศัพท์: -",
              },
            ],
          ],
          margin: [0, 0, 0, 10],
        },

        {
          table: {
            widths: ["*", "auto", "auto", "auto", "auto", "auto", "auto"],
            body: [
              [
                { text: "รายการ", bold: true },
                { text: "ประเภท", bold: true },
                { text: "รวม", bold: true },
                { text: "หัก", bold: true },
                { text: "สุทธิ", bold: true },
                { text: "ราคาต่อหน่วย", bold: true },
                { text: "ราคารวม", bold: true },
              ],
              ...transaction.items.map((item) => [
                item.productName || "-",
                "กก.",
                formatNumber(item.weight),
                formatNumber(item.deductWeight),
                formatNumber(item.netWeight),
                formatNumber(item.pricePerUnit),
                formatNumber(item.netPrice),
              ]),
            ],
          },
          layout: "lightHorizontalLines",
          margin: [0, 10, 0, 10],
        },

        {
          text: `เปิดBatchโดย ${transaction.shop.name || "-"}`,
          margin: [0, 10, 0, 10],
        },

        {
          table: {
            widths: ["*", "auto"],
            body: [
              [
                "ยอดรวมก่อนเสียภาษี",
                { text: formatNumber(totalPrice), alignment: "right" },
              ],
              [
                "ภาษีมูลค่าเพิ่ม (VAT 7%)",
                { text: "0.00", alignment: "right" },
              ],
              [
                "ยอดรวม",
                {
                  text: formatNumber(totalPrice),
                  alignment: "right",
                  bold: true,
                },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 10, 0, 30],
        },

        {
          text: "ลงชื่อ: ____________________________",
          alignment: "right",
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10],
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
        fontSize: 16,
      },
    };

    const pdfDoc = pdfMake.createPdf(docDefinition);
    pdfDoc.getBlob((blob) => resolve(blob));
  });
}

export function generateInvoicePdf(transaction) {
  // รวมราคาสินค้าในรายการ
  const totalPrice = transaction.items.reduce(
    (sum, item) => sum + (item.netPrice || 0),
    0
  );

  const docDefinition = {
    content: [
      { text: "ใบแจ้งหนี้ (Invoice)", style: "header" },

      {
        text: `บริษัท มหานคร เมทอลสแคร็ป จำกัด
92/78 หมู่ที่ 9 ถนนฉลองกรุง แขวงลำผักชี เขตหนองจอก กรุงเทพมหานคร 10530
โทร: 098-2657498 , 089-2029400
เปิด: จันทร์ - เสาร์ เวลา 8.00 - 16.00 น. (ปิดทุกวันอาทิตย์)`,
        margin: [0, 5, 0, 15],
      },

      {
        columns: [
          [
            {
              text: `ชื่อรายการสินค้า: ${transaction.items[0]?.productName || "-"}`,
            },
            { text: `เลขที่Batch: ${transaction.billNumber || "-"}` },
            { text: `เลขที่ใบสั่งซื้อ: ${transaction.orderNumber || "-"}` },
            {
              text: `ส่งไปที่:\n[C${String(transaction.customerId || "-").padStart(3, "0")}] ${
                transaction.customerName || "-"
              }
${transaction.customer?.address || ""}
${transaction.customer?.phone || ""}`,
            },
          ],
          [
            {
              text: transaction.createdAt
                ? (() => {
                    const date = moment(transaction.createdAt).locale("th");
                    const buddhistYear = date.year() + 543;
                    return `วันที่เปิดBatch: ${date.format("DD/MM/")}${buddhistYear} ${date.format("HH:mm")}`;
                  })()
                : "วันที่เปิดBatch: -",
            },
            {
              text: transaction.shipping.createdAt
                ? (() => {
                    const date = moment(transaction.shipping.createdAt).locale(
                      "th"
                    );
                    const buddhistYear = date.year() + 543;
                    return `วันที่ขาย: ${date.format("DD/MM/")}${buddhistYear} ${date.format("HH:mm")}`;
                  })()
                : "วันที่ขาย: -",
            },
            {
              text: `เลขตู้ขนส่ง: ${transaction.shipping.transportBoxNumber || "-"}`,
            },
            { text: `ชื่อคนขับ: ${transaction.shipping.driverName || "-"}` },
            // {
            //   text: `รถขนส่ง: ${transaction.car.type || "-"} ${transaction.car.license || "-"}`,
            // },
            {
              text: transaction.shipping?.phoneNumber
                ? `โทรศัพท์ ${transaction.shipping.phoneNumber.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                : "โทรศัพท์: -",
            },
          ],
        ],
        margin: [0, 0, 0, 10],
      },

      {
        table: {
          widths: ["*", "auto", "auto", "auto", "auto", "auto", "auto"],
          body: [
            [
              { text: "รายการ", bold: true },
              { text: "ประเภท", bold: true },
              { text: "รวม", bold: true },
              { text: "หัก", bold: true },
              { text: "สุทธิ", bold: true },
              { text: "ราคาต่อหน่วย", bold: true },
              { text: "ราคารวม", bold: true },
            ],
            ...transaction.items.map((item) => [
              item.productName || "-",
              "กก.",
              formatNumber(item.weight),
              formatNumber(item.deductWeight),
              formatNumber(item.netWeight),
              formatNumber(item.pricePerUnit),
              formatNumber(item.netPrice),
            ]),
          ],
        },
        layout: "lightHorizontalLines",
        margin: [0, 10, 0, 10],
      },

      {
        text: `เปิดBatchโดย ${transaction.shop.name || "-"}`,
        margin: [0, 10, 0, 10],
      },

      {
        table: {
          widths: ["*", "auto"],
          body: [
            [
              "ยอดรวมก่อนเสียภาษี",
              { text: formatNumber(totalPrice), alignment: "right" },
            ],
            ["ภาษีมูลค่าเพิ่ม (VAT 7%)", { text: "0.00", alignment: "right" }],
            [
              "ยอดรวม",
              {
                text: formatNumber(totalPrice),
                alignment: "right",
                bold: true,
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 10, 0, 30],
      },

      {
        text: "ลงชื่อ: ____________________________",
        alignment: "right",
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 10],
      },
    },
    defaultStyle: {
      font: "THSarabunNew",
      fontSize: 16,
    },
  };

  pdfMake.createPdf(docDefinition).open();
}
